// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
} from '../..';

interface CaptionParams {
  caption?: string;
  photoId: string;
}
interface DeleteParams {
  photoId: string;
}
interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}

export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Path =
  '/api/web/v1/users/properties/floorPlans/photos/caption';

/**
 * Update caption of a floor plan photo
 */
export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption = (
  getParams: CaptionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CaptionParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/floorPlans/photos/delete';

/**
 * Delete a photo of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Path =
  '/api/web/v1/users/properties/floorPlans/photos/upload';

/**
 * Upload a photo for a floor plan
 */
export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadParams,
    UserPropertyFloorPlanPhotoUploadRequestWebDto,
    UserPropertyFloorPlanPhotoUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
